import type { Camera } from "@/libs/20thCenturyFox";
import { createContext } from "react";

/**
 * Initialise with default camera values
 */
export const CameraContext = createContext<Camera>({
  zoom: 1,
  offset: { x: 0, y: 0 },
  viewportSize: { x: 1920, y: 1080 },
});
